export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-format/src/identity.js
// module id = 7Ecm
// module chunks = 0